import React, {useCallback, useEffect, useState} from 'react';

import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';

import AssignedTrainingCard from '../../../components/ManagerInsights/AssignedTrainingCard';
import Container from '../../../components/ManagerInsights/Container';
import EmptyState from '../../../components/ManagerInsights/EmptyState';
import Header from '../../../components/ManagerInsights/Header';
import SearchBar from '../../../components/ManagerInsights/SearchBar';
import SearchContainer from '../../../components/ManagerInsights/SearchContainer';
import * as managerInsightsActions from '../../../state/managerInsights/managerInsightsActions';
import {getManagerInsightsByStore} from '../../../state/managerInsights/managerInsightsSelector';
import {formatedDateString} from '../../../utils/managerInsightUtils';

import managerInsightsStyles from '../styles.module.scss';

const mapStateToProps = (state, ownProps) => {
  const {insightId, managerId} = ownProps.match.params;
  const managerInsightsByStore = getManagerInsightsByStore(state);

  return {
    insightId,
    managerId,
    summary: managerInsightsByStore.get('summary').toJS(),
    contents: managerInsightsByStore.get('contents').toJS(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(managerInsightsActions, dispatch),
});

function AssignedTraining({
  contents,
  goToManagerInsightsHome,
  goToManagerInsightsContentDetail,
  insightId,
  managerId,
  summary,
}) {
  const [keyword, setKeyword] = useState('');
  const [searchMode, setSearchMode] = useState(false);

  useEffect(() => {
    if (!searchMode) {
      setKeyword('');
    }
  }, [searchMode]);

  const renderRow = useCallback(
    (content, index) => {
      const completedUserCount = Object.keys(content.completedUsers).length;
      const nonCompletedUsersCount =
        summary.totalUserCount - completedUserCount;

      return (
        <div key={index}>
          <Container>
            <AssignedTrainingCard
              key={content.id}
              imageUrl={content.image}
              icon={content.icon}
              title={content.title}
              publishedDate={
                content.publishedAt && formatedDateString(content.publishedAt)
              }
              completionInformation={`${completedUserCount} of ${summary.totalUserCount}`}
              users={content.notCompletedUsers}
              noneCompletionInformation={`${content.notCompletedUsers.join(
                ', '
              )}${
                nonCompletedUsersCount > 3
                  ? ` , ${nonCompletedUsersCount - 3} More`
                  : ''
              }`}
              onClick={() =>
                goToManagerInsightsContentDetail({
                  insightId,
                  managerId,
                  cid: content.id,
                  contentType: content.contentType,
                })
              }
            />
          </Container>
        </div>
      );
    },
    [
      goToManagerInsightsContentDetail,
      insightId,
      managerId,
      summary.totalUserCount,
    ]
  );

  return (
    <>
      <div className={managerInsightsStyles.view}>
        <div className={managerInsightsStyles.content}>
          <Header
            title='Assigned Training'
            onClickBack={() => goToManagerInsightsHome({insightId, managerId})}
          />
          <Container>
            <SearchBar
              value={keyword}
              onChange={setKeyword}
              isModeSearch={searchMode}
              onModeChange={setSearchMode}
            />
            {searchMode ? (
              <SearchContainer
                data={contents}
                keyword={keyword}
                type={'content'}
                searchField={'title'}
                rowRender={renderRow}
              />
            ) : (
              contents.map((row, index) => renderRow(row, index))
            )}

            {!contents.length && (
              <EmptyState
                type='content'
                title='Training not found'
                description='There is no training assigned to your team'
              />
            )}
          </Container>
        </div>
      </div>
    </>
  );
}

AssignedTraining.propTypes = {
  contents: PropTypes.array.isRequired,
  goToManagerInsightsHome: PropTypes.func.isRequired,
  goToManagerInsightsContentDetail: PropTypes.func.isRequired,
  insightId: PropTypes.string.isRequired,
  managerId: PropTypes.string.isRequired,
  summary: PropTypes.object.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(AssignedTraining))
);
